import api from './api';

export function getStats() {
  return api.get(`/mesorregioes/stats`);
}
